export default '2.0.0';



// WEBPACK FOOTER //
// ./src/lib/version.js